// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__29ZrV","unreadBadge":"styles_unreadBadge__3rkcf","modalContent":"styles_modalContent__2e6Hr","modal":"styles_modal__1d4cP"};